import { AxiosRequestConfig } from 'axios';
import { isAuthV2, migrateAuthToken, getAccessToken } from '../auth';

/**
 * Attempt to refresh session if existing token is expired.
 */
async function migrateAuthTokenIfNeeded(config: AxiosRequestConfig) {
  if (process.env.NODE_ENV === 'test') {
    return config;
  }

  const accessToken = getAccessToken();
  const isOldAuthToken = accessToken && !isAuthV2();
  if (isOldAuthToken) {
    await migrateAuthToken();
  }

  return config;
}

export default migrateAuthTokenIfNeeded;
